import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { objectParseDates } from '@wz-utilities/object.utilities';
import { SignatureApiModels } from 'models/api/signature-api.models';
import { ConfigurationModels } from 'models/configuration.models';
import { SignatureModels } from 'models/signature.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class SignatureApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'signatures');
  }

  createBrokerContractTransaction(
    request: SignatureApiModels.CreateTransactionRequest,
  ): Observable<SignatureApiModels.CreateTransactionResponse> {
    return this.post<SignatureApiModels.CreateTransactionResponse>(
      '/brokerContract',
      request,
    );
  }

  signDocument(request: SignatureApiModels.SignDocumentRequest) {
    return this.post('/sign', request);
  }

  getRecap(): Observable<SignatureApiModels.Recap> {
    return this.getJson('/recap');
  }

  getSignatureOrderByToken(
    token: string,
  ): Observable<SignatureModels.SignatureOrderDetails> {
    return this.getJson(`/order`, { token }, anonymousOptions).pipe(
      map((x) => objectParseDates(x)),
    );
  }

  getSignatureTransaction(
    id: string,
  ): Observable<SignatureModels.SignatureTransaction> {
    return this.getJson(`/transactions/${id}`, {}, anonymousOptions).pipe(
      map((x) => objectParseDates(x)),
    );
  }

  postStartSignatureOrderTransaction(
    token: string,
  ): Observable<SignatureModels.StartSignatureResponse> {
    return this.post(`/startOrder?token=${token}`, {}, anonymousOptions);
  }
}

const anonymousOptions = { withCredentials: false };
